import Vue from 'www/vue_components'
import { initI18n } from 'www/utils'
import vuetify from 'www/modules/vuetify-plugin'
import ReviewsFilter from 'www/vue_components/common/ReviewsFilter/ReviewsFilter.vue'
import I18NextVue from 'i18next-vue'

async function mountReviewsFilter() {
  const el = document.querySelector('.vue-review-filter')

  if (el) {
    if (window.LANGUAGE_DATA.currentLanguage.iso !== 'ru') {
      const { i18next } = await initI18n({ bundle: 'vue_components/common/ReviewsFilter' })

      Vue.use(I18NextVue, { i18next })
    }

    const instance = new Vue({
      name: 'ReviewsFilterRoot',
      vuetify,
      components: { ReviewsFilter },
    })

    instance.$mount(el)
  }
}

mountReviewsFilter()
